import * as React from 'react';
import { cn } from '@/lib/utils';

export interface EmptyProps {
  image?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

export function Empty({
  image,
  title,
  description,
  action,
  children,
  className,
}: EmptyProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center p-8 sm:p-12',
        className
      )}
    >
      {image && (
        <div className="mb-4 flex items-center justify-center text-muted-foreground/60">
          {image}
        </div>
      )}
      {title && (
        <h4 className="text-base font-semibold text-foreground mb-1">
          {title}
        </h4>
      )}
      {description && (
        <div className="text-sm text-muted-foreground max-w-sm mb-4 leading-relaxed">
          {description}
        </div>
      )}
      {action && <div className="mt-2">{action}</div>}
      {children}
    </div>
  );
}
